import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 3V6.75C10.5 7.59 10.7775 8.37 11.25 9H6.75C7.2375 8.355 7.5 7.575 7.5 6.75V3H10.5ZM12.75 1.5H5.25C4.8375 1.5 4.5 1.8375 4.5 2.25C4.5 2.6625 4.8375 3 5.25 3H6V6.75C6 7.995 4.995 9 3.75 9V10.5H8.2275V15.75L8.9775 16.5L9.7275 15.75V10.5H14.25V9C13.005 9 12 7.995 12 6.75V3H12.75C13.1625 3 13.5 2.6625 13.5 2.25C13.5 1.8375 13.1625 1.5 12.75 1.5Z",
		fill: "#3C59F6"
	})
});
export default SvgPinEmpty;
